import React, { useEffect, useState, useContext } from "react";
import { useAlert } from 'react-alert';
import { UserContext } from "../../../UserContext";
import { useNavigate } from "react-router-dom";

import CenteredPageContainer from "../../components/layout_components/CenteredPageContainer";
import CenteredLoadingIcon from "../../components/common_components/CenteredLoadingIcon"

import PayoutsTable from "./PayoutsTable";
import NoPayoutsCard from "./NoPayoutsCard";
import AddPayoutCard from "./AddPayoutCard";

// API Calls
import CashOutAPI from "../../api/api_calls/CashOutAPI";



function PayoutsPage(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();
    const navigate = useNavigate();

    // State
    const [payouts, setPayouts] = useState([]);
    const [loadComplete, setLoadComplete] = useState(false);
    const [refreshPayouts, setRefreshPayouts] = useState(0);
    const [showRequestPayout, setShowRequestPayout] = useState(false);

    const requestedTotal = (payouts && payouts.length > 0) ? payouts.filter(payout => payout.status === "requested").reduce((acc, payout) => acc + parseFloat(payout.usd_amount), 0.0) : 0.0;

    const getUserPayouts = async () => {
        const response = await CashOutAPI.index();

        if (response.success) {
            setPayouts(response.cash_outs)
            setLoadComplete(true);
        } else {
            alert.show("Unable to load payouts. Try again later", { type: 'error' })
        }
    }

    // Set the page title. Only run once.
    useEffect(() => {
        document.title = 'Payouts | Despark';
    }, []);

    // Refresh the cashouts when the user makes new ones or the page loads.
    useEffect(() => {
        getUserPayouts();
    }, [refreshPayouts]);

    function updatePayouts() {
        getUserPayouts()
    }


    // --------------------------------------------
    // --------------------------------------------
    // ----------------Render Logic---------------
    // --------------------------------------------
    // --------------------------------------------

    // Logic for this page:
    // If they clicked the button to request a payout, show the AddPayoutCard
    // If there are NO payouts, show the NoPayoutsCard
    // If there are payouts, show the PayoutsTable
    return (
        <CenteredPageContainer>
            {!loadComplete ? (
                <CenteredLoadingIcon />
            ) :
                showRequestPayout ?
                    <AddPayoutCard
                        refreshPayouts={refreshPayouts}
                        setRefreshPayouts={setRefreshPayouts}
                        balance={user.balance}
                        requestedTotal={requestedTotal}
                        showRequestPayout={showRequestPayout}
                        setShowRequestPayout={setShowRequestPayout}
                    />
                    :
                    payouts.length === 0 ?
                        <NoPayoutsCard
                            balance={user.balance}
                            setShowRequestPayout={setShowRequestPayout}
                            navigate={navigate}
                        />
                        :
                        <PayoutsTable
                            payouts={payouts}
                            balance={user.balance}
                            showRequestPayout={showRequestPayout}
                            setShowRequestPayout={setShowRequestPayout}
                            refreshPayouts={refreshPayouts}
                            updatePayouts={updatePayouts}
                        />

            }
        </CenteredPageContainer>
    )
}

export default PayoutsPage